import * as Yup from "yup";
const createProject3ValidationSchema = Yup.object({
  name_of_account: Yup.string().required("Name of account is required"),
  beneficiary_bank: Yup.string().required("Beneficiary goal is required"),
  signatories: Yup.string().required("Signatories is required"),
  account_number: Yup.number().required("Account number is required"),
});

export { createProject3ValidationSchema };
